import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import logo from "../../src/assets/images/Klinicq_logo.webp";

/**
 * 1. CRITICAL CSS 
 * Defining this outside the class ensures it's available 
 * immediately when the JS executes, reducing "Element Render Delay".
 */
const logoStyle = {
    width: '250px',
    height: 'auto',
    aspectRatio: '250 / 100', // Pre-calculates space for the logo
    display: 'block'
};

class Headerweb extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSticky: false,
            isAboutView: false,
            isProductView: false,
            isBenifitView: false,
            isContactView: false,
            isSolutionView: false,
            isSolutionClinical: false,
            isSolutionAppointment: false,
            isExpanded: false,
            showMenu: false,
            isOpen: false,
        };
    }

    componentDidMount() {
        /**
         * 2. EARLY DISCOVERY HACK
         * Triggers the browser to start downloading the logo 
         * the moment the component mounts.
         */
        const img = new Image();
        img.src = logo;

        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }

    handleScroll = () => {
        if (window.scrollY >= 50) {
            this.setState({ isSticky: true });
        } else {
            this.setState({ isSticky: false });
        }
    };

    handleResize = () => {
        if (window.innerWidth > 768) {
            this.setState({ showMenu: false });
        }
    };

    toggleMenu = () => {
        this.setState(prevState => ({ showMenu: !prevState.showMenu }));
    };

    toggleDropdown = () => {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    };

    userAuth = () => {
        this.props.history.push('/login');
    };

    bookademo = () => {
        this.props.history.push('/bookdemo');
    };

    render() {
        const { isSticky, showMenu, isOpen } = this.state;
        const { isClass1Show } = this.props;

        return (
            <div className='header-section'>
                <header className={isSticky ? 'sticky-element' : 'nav-element'}>
                    <div className='nav-section'>
                        <nav className="navbar navbar-expand-lg navbar-light bg-white">
                            <div className="container-fluid">
                                <div className='d-flex'>
                                    <a className="navbar-brand klinic-logo" href="/">
                                        {/* 3. OPTIMIZED IMAGE TAG
                                            - fetchPriority: Moves it to the front of the network queue.
                                            - loading="eager": Forces immediate load.
                                            - decoding="sync": Avoids a blank frame while decoding.
                                        */}
                                        <img 
                                            src={logo} 
                                            alt="Klinicq Logo" 
                                            className="nav-logo"
                                            // style={logoStyle}
                                            fetchPriority="high"
                                            loading="eager" 
                                            decoding="sync"
                                        />
                                    </a>
                                </div>
                                 
                                <button className="navbar-toggler" type="button" onClick={this.toggleMenu} aria-controls="navbarNavAltMarkup" aria-expanded={showMenu} aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                </button>

                                {showMenu && (
                                    <div className={`collapse navbar-collapse ${showMenu ? 'show' : ''}`} id="navbarNavAltMarkup">
                                        <ul className="navbar-nav width-navbar">
                                            <li className="nav-item">
                                                <NavLink exact to="/about-us" className="nav-link">About Us</NavLink>
                                            </li>
                                            <li className={`nav-item dropdown ${isOpen ? "show" : ""}`}>
                                                <a className="nav-link dropdown-toggle" onClick={this.toggleDropdown} role="button" aria-haspopup="true" aria-expanded={isOpen}>
                                                    Solution <span className="ms-2"><i className={`fas ${isOpen ? "fa-chevron-up" : "fa-chevron-down"}`}></i></span>
                                                </a>
                                                {isOpen && (
                                                    <div className="dropdown-menu show">
                                                        <a className="dropdown-item" href="/hospital-managment-software"><i className="fas fa-hospital"></i> Hospital</a>
                                                        <a className="dropdown-item" href="/doctor-managment-software"><i className="fas fa-user-md"></i> Doctor</a>
                                                        <a className="dropdown-item" href="/patient-managment-software"><i className="fas fa-procedures"></i> Patients</a>
                                                        <a className="dropdown-item" href="/pharmacy-managment-software"><i className="fa-solid fa-store"></i> Pharmacy</a>
                                                    </div>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                <NavLink exact to="/features" className="nav-link">Product Feature</NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink exact to="/benefits" className="nav-link">Benefits</NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink exact to="/contact" className="nav-link">Contact</NavLink>
                                            </li>
                                        </ul>
                                        <div className='d-flex justify-content-end'>
                                            <button className='btn-ghost'>
                                                <a href='/bookdemo' style={{ textDecoration: 'none', color: 'white' }}>Get Our App</a>
                                            </button>
                                            <button className='btn-ghost1' type='button' style={{ backgroundColor: 'white', border: 'none', fontSize: '18px' }}>
                                                <a href='/login' style={{ textDecoration: 'none', color: '#0C5B98', fontSize: '16px' }}>
                                                    <i className="fa-regular fa-user"></i> Login
                                                </a>
                                            </button>
                                        </div>
                                    </div>
                                )}
                
                                <div className="collapse navbar-collapse d-lg-block d-none" id="navbarNavAltMarkup">
                                    <div className={`${isClass1Show === true ? 'nav-show' : ''} collapse navbar-collapse navbarNav justify-content-end mr-3 navlist`} id="navbarSupportedContent">
                                        <ul className="navbar-nav width-navbar">
                                            <li className="nav-item dropdown">
                                                <NavLink exact to="/about-us" className="dropdown-toggle option-list text-decoration-none custom-active" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                                                    About us
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown">
                                                <a className="dropdown-toggle option-list text-decoration-none custom-active" onClick={this.toggleDropdown} role="button" aria-haspopup="true" aria-expanded={isOpen}>
                                                    Solution <span className="ms-3"><i className={`fas ${isOpen ? "fa-chevron-up" : "fa-chevron-down"}`}></i></span>
                                                </a>
                                                {isOpen && (
                                                    <div className="dropdown-menu show">
                                                        <a className="dropdown-item text-decoration-none" style={{ padding: "10px 25px" }} href="/hospital-managment-software"><i className="fas fa-hospital"></i> Hospital</a>
                                                        <a className="dropdown-item text-decoration-none" style={{ padding: "10px 25px" }} href="/doctor-managment-software"><i className="fas fa-user-md"></i> Doctor</a>
                                                        <a className="dropdown-item text-decoration-none" style={{ padding: "10px 25px" }} href="/patient-managment-software"><i className="fas fa-procedures"></i> Patients</a>
                                                        <a className="dropdown-item text-decoration-none" style={{ padding: "10px 25px" }} href="/pharmacy-managment-software"><i className="fa-solid fa-store"></i> Pharmacy</a>
                                                    </div>
                                                )}
                                            </li>
                                            <li className="nav-item1 dropdown">
                                                <a className='dropdown-toggle option-list text-decoration-none custom-active' href="/features">Product Feature</a>
                                            </li>
                                            <li className="nav-item1 dropdown">
                                                <a className='dropdown-toggle option-list text-decoration-none custom-active' href="/benefits">Benefits</a>
                                            </li>
                                            <li className="nav-item1 dropdown">
                                                <a className='dropdown-toggle option-list text-decoration-none custom-active' href="/contact">Contact</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='d-flex'>
                                        <button className='btn-ghost'><a href='#download' style={{ textDecoration: 'none', color: 'white' }} >Get Our App</a></button>
                                        <div className='mx-2'>
                                            <button className='btn-ghost1' type='button' style={{ backgroundColor: 'white', border: 'none', fontSize: '18px' }}>
                                                <a href='/login' style={{ textDecoration: 'none', color: '#0C5B98', fontSize: '16px' }}>
                                                    <i className="fa-regular fa-user"></i> Login
                                                </a>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </header>
            </div>
        );
    }
}

export default Headerweb;